import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

interface AuthGateProps {
  children: React.ReactNode;
}

/**
 * AuthGate blocks rendering until authentication state is fully hydrated
 * This prevents authentication-related race conditions on page reload
 */
export const AuthGate: React.FC<AuthGateProps> = ({ children }) => {
  const { loading } = useAuth();

  // PERF DIAGNOSTIC: Track when AuthGate unblocks
  React.useEffect(() => {
    if (!loading) {
      console.log(`🔓 [PERF] AuthGate unblocked at ${new Date().toISOString().split('T')[1]}`);
    }
  }, [loading]);

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return <>{children}</>;
};